export default {
  metadata: {
    version: '1.0.0',
    id: 'spinner-1.0.0',
    name: 'JDSSpinner'
  },
  hierarchy: {
    container: [
      {
        'spinner-container': [
          {
            'arc-container': [
              'base-arc',
              'normal-arc',
              'third-arc',
              'second-arc',
              'first-arc'
            ]
          }
        ]
      },
      'jds-text'
    ]
  },
  base: {
    container: {
      'background-color': '{s_0}',
      gap: '{s_1}',
      'justify-content': '{s_2}',
      'align-items': '{s_3}',
      'flex-direction': '{s_4}'
    },
    'spinner-container': {
      size: '{s_5}'
    },
    'arc-container': {
      'flex-direction': '{s_6}',
      'justify-content': '{s_7}',
      'align-items': '{s_8}',
      size: '{s_9}'
    },
    'base-arc': {
      fill: '{s_10}',
      radius: '{s_11}',
      arcWidth: '{s_12}',
      start: '{s_13}',
      end: '{s_14}',
      'z-index': 0
    },
    'normal-arc': {
      fill: '{s_15}',
      radius: '{s_16}',
      arcWidth: '{s_17}',
      start: '{s_18}',
      end: '{s_19}',
      'z-index': 1,
      'animation-duration': '{s_20}',
      animate: true
    },
    'first-arc': {
      hidden: true,
      fill: '{s_21}',
      radius: '{s_22}',
      arcWidth: '{s_23}',
      start: '{s_24}',
      end: '{s_25}',
      'z-index': 3,
      'animation-delay': '{s_26}',
      'animation-duration': '{s_27}',
      animate: true
    },
    'second-arc': {
      hidden: true,
      fill: '{s_28}',
      radius: '{s_29}',
      arcWidth: '{s_30}',
      start: '{s_31}',
      end: '{s_32}',
      'z-index': 2,
      'animation-delay': '{s_33}',
      'animation-duration': '{s_34}',
      animate: true
    },
    'third-arc': {
      hidden: true,
      fill: '{s_35}',
      radius: '{s_36}',
      arcWidth: '{s_37}',
      start: '{s_38}',
      end: '{s_39}',
      'z-index': 1,
      'animation-duration': '{s_40}',
      animate: true
    },
    'jds-text': {
      'font-family': '{text_117}',
      color: '{text_21}',
      'font-size': '{text_116}',
      'line-height': '{text_118}',
      'letter-spacing': '{text_119}',
      'font-weight': '{text_120}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    labelPosition: {
      bottom: {
        container: {
          'flex-direction': '{s_41}'
        }
      }
    },
    size: {
      small: {
        container: {
          gap: '{s_42}'
        },
        'spinner-container': {
          size: '{s_43}'
        },
        'base-arc': {
          arcWidth: '{s_44}',
          radius: '{s_45}'
        },
        'normal-arc': {
          arcWidth: '{s_46}',
          radius: '{s_47}'
        },
        'first-arc': {
          arcWidth: '{s_48}',
          radius: '{s_49}'
        },
        'second-arc': {
          arcWidth: '{s_50}',
          radius: '{s_51}'
        },
        'third-arc': {
          arcWidth: '{s_52}',
          radius: '{s_53}'
        },
        'jds-text': {
          'font-family': '{text_132}',
          'font-size': '{text_131}',
          'line-height': '{text_133}',
          'letter-spacing': '{text_134}',
          'font-weight': '{text_135}'
        }
      }
    },
    isOverlay: {
      true: {
        'jds-text': {
          color: '{text_18}'
        }
      }
    },
    _determinate: {
      true: {
        'normal-arc': {
          animate: false
        }
      }
    }
  },
  combination: [
    {
      small: {
        bottom: {
          container: {
            'flex-direction': '{s_55}'
          }
        }
      }
    },
    {
      false: {
        inline: {
          'normal-arc': {
            fill: '{s_54}'
          }
        },
        vibrant: {
          'normal-arc': {
            hidden: true
          },
          'first-arc': {
            hidden: false
          },
          'second-arc': {
            hidden: false
          },
          'third-arc': {
            hidden: false
          }
        }
      }
    }
  ],
  combination_config: [
    ['size', 'labelPosition'],
    ['_determinate', 'kind']
  ],
  api: {
    config: {
      labelPosition: {
        values: ['right', 'bottom'],
        doc_description:
          'It determines the position of the label. Note: if using a small spinner, the label can only be positioned on the right.'
      },
      size: {
        values: ['medium', 'small'],
        doc_description: 'It can be used to control size od Spinner.'
      },
      kind: {
        values: ['normal', 'inline', 'vibrant'],
        doc_description:
          'It determines the appearance of the spinner .`inline` inherits from text color,`normal`: single color, `vibrant`: three color.'
      },
      isOverlay: {
        values: [false, true]
      },
      _determinate: {
        values: [false, true]
      }
    },
    data: {
      'normal-arc': {
        end: {
          type: 'float',
          name: 'value',
          function: true,
          doc_description: 'It can be used to take value of spinner from user.'
        }
      },
      'jds-text': {
        value: {
          type: 'string',
          name: 'label',
          doc_description: 'It displays the label of Spinner.'
        }
      }
    },
    a11y: {
      container: {
        properties: {
          'aria-label': {
            name: 'ariaLabel',
            value: 'Loading'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          },
          'aria-live': {
            name: 'ariaLive',
            value: 'polite'
          }
        }
      }
    }
  }
};
